// Bakım modunun global durumu. maintenanceInterceptor yazar, portal kabuğu okur.

import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MaintenanceState {
  private _message = signal<string | null>(null);

  /** Dolu ise bakım modundayız — kabuk tam ekran paneli gösterir. */
  readonly message = this._message.asReadonly();

  activate(message: string) {
    // Aynı mesajı tekrar yazmak gereksiz change-detection tetikler.
    if (this._message() !== message) this._message.set(message);
  }

  /** Kullanıcı "tekrar dene" dediğinde — bir sonraki 503 yeniden aktive eder. */
  clear() {
    this._message.set(null);
  }
}
